














import { VueCustom } from 'vue-custom';
import EventsManager from 'managers/events.manager';
import { ANIMATION_FINAL } from 'constants/animations';
import { ANIMATION_CONFIGS } from 'constants/animation-config';

const ANIMATION_CONFIG = ANIMATION_CONFIGS[ANIMATION_FINAL];


export default VueCustom.extend({
  name: 'animation-final-encyclopedia',
  data: () => ({
    isActive: false,
  }),
  computed: {
    id() {
      return ANIMATION_CONFIG.encyclopediaId;
    },
    classes(): Record<string, boolean> {
      return {
        'js-active': this.isActive,
      };
    },
  },
  mounted() {
    EventsManager.on('ANIMATION_FINAL_SINGLE_END', () => this.onElementAnimationEnd());
  },
  methods: {
    onElementAnimationEnd() {
      this.isActive = true;
    },
    onAnimation({ animationName }: AnimationEvent) {
      if (animationName !== ANIMATION_CONFIG.encyclopedia) return;

      this.isActive = false;
    },
  },
});
